import Vue from "vue";
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const pcHome = () => import("@/views/pc/home/home")
const blankHome = () => import("@/views/blank")
const eula = () => import("@/views/rules/eula")
const privacy = () => import("@/views/rules/privacy")

const routes = [
  {
    path: "*",
    redirect: "/"
  },
  {
    path: '/',
    name: 'Blank',
    component: blankHome,
    meta: {
      title: 'Gamely'
    }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: privacy,
    meta: {
      title: 'Privacy Policy'
    }
  },
  {
    path: '/eula',
    name: 'eula',
    component: eula,
    meta: {
      title: 'End User License Agreement'
    }
  },
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: pcHome,
  //   meta: {
  //     title: 'Gamely'
  //   }
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to,from,next) => {
  if(to.matched[0].meta.title)
    document.title = to.meta.title
  next()
})

export default router
